<template>
  <div>

    <b-row>
      <b-col sm="12">
        <b-card>

          <div slot="header">
            <strong :style="{color: config.primaryColor}">History API </strong>
            <small :style="{color: config.secondaryColor}"> Filter Form</small>
          </div>

          <b-row>
            <b-col sm="6">

              <b-form-group>
                <label :style="{color: config.primaryColor}">Store Number Filter</label>
                <b-form-input type="text" v-model="storeNumberFilter" placeholder="Store Number Filter"></b-form-input>
              </b-form-group>

            </b-col>

            <b-col sm="6">

              <b-form-group>
                <label :style="{color: config.primaryColor}">Site Id Filter</label>
                <b-form-input type="text" v-model="siteIdFilter" placeholder="Site ID Filter"></b-form-input>
              </b-form-group>

            </b-col>

          </b-row>

          <b-row>

            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Refresh ID Filter</label>
                <b-form-input type="text" v-model="refreshIdFilter" placeholder="Refresh ID Filter"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Aggregate Batch ID Filter</label>
                <b-form-input type="text" v-model="aggregateBatchIdFilter"
                              placeholder="Aggregate ID Filter"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Status Filter</label>
                <b-form-select size="lg" :plain="true" v-model="statusFilter"
                               :options="statusFilterOptions"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col xs="12">
              <b-form-group>
                <label :style="{color: config.primaryColor}">From Date - To Date Range Filter</label><br>
                <date-picker v-model="times" range type="datetime" lang="en" :format="timeFormat"></date-picker>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row>
            <b-col xs="12">
              <div class="form-group form-actions">
                <button @click="getHistory" class="btn btn btn-sm btn-secondary btn-secondary">Get History</button>
              </div>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>

    <Table v-show="filteredHistories.length > 0"
           caption="History Documents"
           :data="filteredHistories"
           :fields="historyFields"
           :hover="true"
           :perPage="25">
    </Table>

    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>

  </div>
</template>

<script>
  import moment from 'moment';

  import store from './store';

  import SSR from './ssr';

  import Table from './Table';
  import Loading from 'vue-full-loading';
  import DatePicker from 'vue2-datepicker';


  const baseUrl = "https://30mx0s6wy4.execute-api.us-east-1.amazonaws.com/dev";

  export default {
    name: "CompanyHistory",
    mixins: [SSR],
    components: {DatePicker, Loading, Table},
    props: ['config', 'companyId', 'accessToken'],

    data() {
      return {
        store,
        state: store.state,

        times: [],
        histories: [],
        siteIdFilter: null,
        refreshIdFilter: null,
        aggregateBatchIdFilter: null,

        storeNumberFilter: null,
        statusFilter: null,
        statusFilterOptions: ['', 'success', 'failure'],

        loading: false,
        historyFields: ['status', 'store_number', 'site_id', 'start_time', 'end_time'],
        loadingLabel: "Loading History...",
        timeFormat: 'YYYY-MM-DD HH:mm:ss',
        timePickerOptions: {
          start: '00:00',
          step: '00:30',
          end: '23:30'
        }
      }
    },

    methods: {
      getHistory(skip, callingSelf) {
        this.loading = true;

        skip = skip || 0;
        callingSelf = callingSelf || false;
        let additionalParams = {};

        if (callingSelf) {
          additionalParams["skip"] = skip
        }

        this.$http.get(`${this.olBaseURL}/history`, {
          headers: this.headers,
          params: {...this.params, ...additionalParams}
        }).then(res => {

          if (callingSelf && res.body) {

            if (res.body.items && res.body.items.length > 0) {
              this.histories.push(...res.body.items);
            }

          } else {

            if (res.body.items && res.body.items.length > 0) {
              this.histories = res.body.items;
            }

            this.loading = false;
          }

          let pageSize = res.body.page_size;
          let pageCount = res.body.page_count;
          let currentPage = res.body.current_page;

          if (currentPage !== pageCount) {
            this.getHistory(pageSize * currentPage + 1, true)
          } else {
            this.loading = false;
          }

        }, err => {
          console.log(err);
          this.loading = false;
        })
      }
    },

    computed: {
      headers() {
        let h = {
          Authorization: `Bearer ${this.accessToken}`,
          "X-Company-Id": this.companyId
        };

        if (this.siteIdFilter) {
          h["X-Site-Ids"] = this.siteIdFilter
        }

        return h;
      },
      params() {

        let p = {
          "limit": 2000,
          "from_date": this.fromTime,
          "to_date": this.toTime
        };

        if (this.storeNumberFilter) {
          p["store_number"] = this.storeNumberFilter;
        }

        if (this.refreshIdFilter) {
          p["refresh_id"] = this.refreshIdFilter
        }

        if (this.statusFilter) {
          p["status"] = this.statusFilter
        }

        if (this.aggregateBatchIdFilter) {
          p["batch_id"] = this.aggregateBatchIdFilter;
        }

        return p;

      },

      fromTime() {
        if (this.times.length > 0) {
          return moment.utc(this.times[0], this.timeFormat).format();
        }
      },

      toTime() {
        if (this.times.length > 0) {
          return moment.utc(this.times[1], this.timeFormat).format();
        }
      },

      filteredHistories() {
        let filtered = this.histories;

        if (this.storeNumberFilter) {
          filtered = filtered.filter(hist => hist.store_number === this.storeNumberFilter);
        }

        if (this.refreshIdFilter) {
          filtered = filtered.filter(hist => hist.refresh_id === this.refreshIdFilter)
        }

        if (this.siteIdFilter) {
          filtered = filtered.filter(hist => hist.site_id === this.siteIdFilter)
        }

        if (this.statusFilter) {
          filtered = filtered.filter(hist => hist.status === this.statusFilter)
        }

        if (this.aggregateBatchIdFilter) {
          filtered = filtered.filter(hist => hist.batch_id === this.aggregateBatchIdFilter)
        }

        return filtered;
      },
    }
  }
</script>

<style scoped>
  select.form-control[size], select.form-control[multiple] {
    height: 35px;
  }

</style>
